import React, { useEffect, createElement } from 'react';
import { UrgencyBar } from './components/UrgencyBar';
import { HeroSection } from './components/HeroSection';
import { HookSection } from './components/HookSection';
import { PainSection } from './components/PainSection';
import { RevelationSection } from './components/RevelationSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { OfferSection } from './components/OfferSection';
import { PricingSection } from './components/PricingSection';
import { FAQSection } from './components/FAQSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { ClosingSection } from './components/ClosingSection';
import { Footer } from './components/Footer';
declare global {
  interface Window {
    fbq: (...args: any[]) => void;
    _fbq: any;
  }
}
const PIXEL_ID = '1583309636230630';
function initFacebookPixel() {
  if (window.fbq) return;
  const n: any = window.fbq = function (...args: any[]) {
    n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
  };
  if (!window._fbq) window._fbq = n;
  n.push = n;
  n.loaded = true;
  n.version = '2.0';
  n.queue = [];
  const script = document.createElement('script');
  script.async = true;
  script.src = 'https://connect.facebook.net/en_US/fbevents.js';
  const firstScript = document.getElementsByTagName('script')[0];
  firstScript?.parentNode?.insertBefore(script, firstScript);
}
export function App() {
  useEffect(() => {
    initFacebookPixel();
    window.fbq('init', PIXEL_ID);
    window.fbq('track', 'PageView');
  }, []);
  return <div className="min-h-screen bg-cyber-black text-gray-300 font-sans relative selection:bg-cyber-neon selection:text-cyber-black" data-id="element-0">
      {/* Global Scanline Overlay */}
      <div className="scanlines" data-id="element-1"></div>

      {/* Sticky Urgency Bar */}
      <UrgencyBar data-id="element-2" />

      {/* Main Content */}
      <main data-id="element-3">
        <HeroSection data-id="element-4" />
        <HookSection data-id="element-5" />
        <PainSection data-id="element-6" />
        <RevelationSection data-id="element-7" />
        <TestimonialsSection data-id="element-8" />
        <OfferSection data-id="element-9" />
        <PricingSection data-id="element-10" />
        <FAQSection data-id="element-11" />
        <GuaranteeSection data-id="element-12" />
        <ClosingSection data-id="element-13" />
      </main>

      {/* Footer */}
      <Footer data-id="element-14" />
    </div>;
}